import React, { Component } from 'react';
import styled from 'styled-components';

import ContactsFormBlock from '../../common/ContactsFormBlock';
import Footer from '../../components/Footer';

import mediaWidth from '../../utils/mediaWidth/mediaWidth';
import Analytics from '../../services/Analytics';

import StartScreenTeam from '../../components/StartScreenTeam';
import OurTalents from '../../components/OurTalents';

class Team extends Component {
    componentDidMount() {
        Analytics.pageView('/team', 'Team Page');
    }

    render() {
        const { className, handleChangePage, scrollRef } = this.props;

        return (
            <Root className={className}>
                <StartScreenTeam />
                <OurTalents />
                <StyledContactsFormBlock
                    scrollRef={scrollRef}
                />
                <Footer handleChangePage={handleChangePage} />
            </Root>
        );
    }
}

const Root = styled.div``;

const StyledContactsFormBlock = styled(ContactsFormBlock)`
    padding-top: 64px;
    padding-bottom: 64px;
    background: #FFF;

    ${mediaWidth.m} {
        padding-top: 96px;
        padding-bottom: 96px;
    };
`;

export default Team;
